import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { ServiceName } from "../../../../../../../../constants";
import { fontMixin, getColorByService } from "../../../../../../../../styles";

interface HeaderProps {
	$service: ServiceName;
}

export const H_Container = styled(motion.div)<HeaderProps>`
	width: 100%;
	height: 20px;
	border-radius: 0 0 10px 10px;
	display: grid;
	grid-template-columns: 1fr;
	${fontMixin({ size: 12 })};
	line-height: 15px;
	text-align: center;
	align-items: center;

	${({ $service }) => {
		const color = getColorByService($service);

		return css`
			background: ${color};
		`;
	}}
`;
